import { render, staticRenderFns } from "./AccountPendingAlert.vue?vue&type=template&id=2d4b8856&scoped=true&"
import script from "./AccountPendingAlert.vue?vue&type=script&lang=ts&"
export * from "./AccountPendingAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b8856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
